import React from 'react';
import GameButtonWithText from "../GameButtonWithText";
import GameButtonWithIcon from "../GameButtonWithIcon";
import reseach_icon from "../../../images/gameplay_ui/icons/research icon.svg"
import info_icon from "../../../images/gameplay_ui/icons/info_icon.svg";

const height = "40px";
const LineColors = [
    ["#F8f8f8", "#f3f3f3"],
    ["#efefef", "#eaeaea"]
]
class TenderCard extends React.Component{

    render() {
        let mainStyle = {
            display: "flex",
            maxHeight: height,
            width: "847px",
            fontSize: `${this.props.fontSize ?? 10}px`,
            fontWeight: this.props.fontWeight ?? "bold",
            textAlign: "center",
            verticalAlign: "middle",
            lineHeight: height
        }
        let colorColumnEven = {
            background: LineColors[this.props.index % 2][0],
            maxHeight: height
        }

        let colorColumnOdd = {
            background: LineColors[this.props.index % 2][1],
            maxHeight: height
        }

        let colorStart = ["#8CED00", "#56CCF2"];
        let colorEnd = ["#66AE04", "#2D9CDB"];

        let order = {
            start: colorStart[this.props.isOrdered ? 1 : 0],
            end: colorEnd[this.props.isOrdered ? 1 : 0],
        };

        let research = {
            start: colorStart[this.props.isResearched ? 1 : 0],
            end: colorEnd[this.props.isResearched ? 1 : 0],
        };

        let itemText = this.props.isOrdered ? "Отправлено" : "Участвовать";
        let itemIcon = this.props.isResearched ? info_icon : reseach_icon;

        let buttons = [];
        buttons.push(<GameButtonWithText key={'t-1'} colorStart={order.start} colorEnd={order.end} onClick={this.props.onPlaceOrder} title={itemText} width={118} height={30}/>)
        buttons.push(<GameButtonWithIcon key={'t-2'} tooltip={"Маркетинговое исследование"} colorStart={research.start} colorEnd={research.end} onClick={this.props.onBuyResearch} icon={itemIcon} width={30} height={30}/>)
        buttons = <div style={{
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "10px"
        }}>
            {buttons}</div>
        return <div style={mainStyle}>
            <div style={{
                ...colorColumnOdd,
                width: "110px"
            }}>
                {this.props.code}
            </div>
            <div style={{
                ...colorColumnEven,
                width: "110px"
            }}>
                {this.props.client}
            </div>
            <div style={{
                ...colorColumnOdd,
                width: "110px"
            }}>
                {this.props.from}
            </div>
            <div style={{
                ...colorColumnEven,
                width: "110px"
            }}>
                {this.props.to}
            </div>
            <div style={{
                ...colorColumnOdd,
                width: "110px"
            }}>
                {this.props.cargo}
            </div>
            <div style={{
                ...colorColumnEven,
                width: "110px"
            }}>
                {this.props.weight !== "0" ? this.props.weight : "Выполнен"}
            </div>
            <div style={{
                ...colorColumnEven,
                width: "168px",
                lineHeight: "15px",
                textAlign: "left",
                paddingLeft: "10px",
                paddingTop: "5px",
            }}>
                {this.props.costParticipate ?? buttons}
            </div>
        </div>;
    }
}
export default TenderCard;
